export class GiftGuideFilter extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      form: '[js-filter-form]',
      chip: '[js-filter][type="checkbox"]',
      chipLabel: 'label.gg-item',
      loader: 'loading-spinner',
      collectionGrid: 's-collection-grid',
      productsGrid: '[js-products-grid]',
      pagination: '[js-pagination]'
    };

    this._applyTimer = null;
    this._applyInFlight = false;
  }

  connectedCallback() {
    this._form = this.querySelector(this._selectors.form);
    this._loader = this.querySelector(this._selectors.loader);
    if (!this._form) return;

    this._form.addEventListener('change', this._onChange);
  }

  disconnectedCallback() {
    this._form?.removeEventListener('change', this._onChange);
    clearTimeout(this._applyTimer);
  }

  _onChange = (evt) => {
    const input =
      evt.target.closest(this._selectors.chip) ||
      evt.target.closest(this._selectors.chipLabel)?.querySelector(this._selectors.chip);
    if (!input || !this._form.contains(input)) return;

    this._enforceSingle(input);

    clearTimeout(this._applyTimer);
    this._applyTimer = setTimeout(this._applyFilter, 150);
  }

  _enforceSingle(keepInput) {
    if (!keepInput.checked) return;

    this._form.querySelectorAll(this._selectors.chip).forEach((input) => {
      if (input !== keepInput) input.checked = false;
    });
  }

  _swapProductGrid(parsedHTML) {
    const liveGrid = document.querySelector(this._selectors.collectionGrid);
    if (!liveGrid) return;

    const remoteGrid =
      parsedHTML.querySelector(`${this._selectors.collectionGrid}[data-id="${liveGrid.dataset.id}"]`) ||
      parsedHTML.querySelector(this._selectors.collectionGrid);
    if (!remoteGrid) return;

    [this._selectors.productsGrid, this._selectors.pagination].forEach((selector) => {
      const oldEl = liveGrid.querySelector(selector);
      const newEl = remoteGrid.querySelector(selector);
      if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
    });
  }

  _applyFilter = async () => {
    if (this._applyInFlight) return;
    this._applyInFlight = true;
    this._loader?.setAttribute('loading', '');

    const searchParams = new URLSearchParams(new FormData(this._form)).toString();
    const url = searchParams ? `${window.location.pathname}?${searchParams}` : window.location.pathname;

    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;

      const parsedHTML = new DOMParser().parseFromString(await response.text(), 'text/html');

      this._swapProductGrid(parsedHTML);

      document.dispatchEvent(new CustomEvent('filter:change', {
        detail: { parsedHTML, scope: 'gift-guide' }
      }));
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

      history.pushState({ searchParams }, '', url);

      const freshForm = parsedHTML.querySelector(`gift-guide-filter ${this._selectors.form}`);
      if (freshForm) this._form.innerHTML = freshForm.innerHTML;
    } finally {
      this._loader?.removeAttribute('loading');
      this._applyInFlight = false;
    }
  }
}

if (!customElements.get('gift-guide-filter')) {
  customElements.define('gift-guide-filter', GiftGuideFilter);
}
